var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { DeskPool } from '../../DeskPool';
import { useAppDispatch, useAppSelector } from '../../../../hooks';
import { selectMatchState, setMatchState } from '../../../../store/match';
import { useErrorHandler } from '../../../../hooks/useErrorHandler';
import { selectVoteDirection, startPlayerIntroduction, } from '../../../../api';
export function SelectRoundDirection({ useCase }) {
    var _a;
    const matchState = useAppSelector(selectMatchState);
    const dispatch = useAppDispatch();
    const { errorHandler } = useErrorHandler();
    const [candidate, setCandidate] = useState(null);
    const candidates = ((_a = matchState === null || matchState === void 0 ? void 0 : matchState.state) === null || _a === void 0 ? void 0 : _a.candidates) || [];
    const onGameButtonClick = () => __awaiter(this, void 0, void 0, function* () {
        if (candidate === null) {
            return;
        }
        try {
            if (useCase === 'INTRODUCTION') {
                const result = yield startPlayerIntroduction(candidate.player.id);
                dispatch(setMatchState(result));
            }
            else {
                const result = yield selectVoteDirection(candidate.player.id, candidate.direction);
                dispatch(setMatchState(result));
            }
        }
        catch (err) {
            errorHandler(err);
        }
    });
    const onPlayerClickAction = (playerId) => {
        const found = candidates.find((c) => c.id === playerId);
        if (found) {
            const player = matchState === null || matchState === void 0 ? void 0 : matchState.players.find((p) => p.id === playerId);
            if (player) {
                const newCandidate = {
                    player,
                    direction: found.direction,
                };
                setCandidate(newCandidate);
            }
        }
    };
    const gameButtonState = {
        text: `${candidate === null || candidate === void 0 ? void 0 : candidate.player.player.gameName} начал(а)`,
        visible: candidate !== null,
        onClick: onGameButtonClick,
    };
    return _jsx(DeskPool, { onPlayerClickAction: onPlayerClickAction, gameButtonState: gameButtonState });
}
